import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Button, CardActionArea, CardActions, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import Breadcrumbs from "../../components/Common/Breadcrumb"
import courseImg from "../../assets/images/Digital-Marketing.jpg";
import webimg6 from "../../assets/images/webimg6.jpg";
import webimg2 from "../../assets/images/webimg2.jpg";
import { Link, useHistory } from "react-router-dom";
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import { Col, Row, CardText, Table, CardTitle } from "reactstrap";
import Marquee from "react-fast-marquee";
import "../../helpers/helper";
import Swal from 'sweetalert2'
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  const [error, setError] = useState(null);
  const [tid, setTid] = useState(null);
  const [submitting, setSub] = useState(false);
  const [address, setAddress] = useState(null);
  const [file, setFile] = useState();
  const [cReqs, setCReqs] = useState(null);
  const [cpReqs, setCpReqs] = useState([]);

  const [value, setValue] = useState(0);
  const [invoices, setInvoice] = useState(null);
  const [total, setTotal] = useState(0);
  const [selectedCourses, setSelectedCourses] = useState([]); // Update for multiple selections

  const navigateToModule = async (moduleId) => {
    const certificate = await axios.get(global.config.URL.api.lms + 'download-certificate/' + moduleId);
    const win = window.open(certificate.data.pdf, '_blank');
    if (win != null) {
      win.focus();
    }
  };

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${global.config.Token}`;

    const getData = async () => {
      const invoices = await axios.get(global.config.URL.api.lms + 'my-certificates');
      if (invoices.data.feedback) {
        Swal.fire({
          title: "First Submit Your Feedback",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Show Questions",
          confirmButtonColor: "green",
          denyButtonText: `Cancel`
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            props.history.push({
              pathname: '/zoom-sessions',
              state: {
                course: invoices.data.course_id,
              }
            })
          } else if (result.isDenied) {
            props.history.push({
              pathname: '/dashboard',
            })
          }
        });
      } else {
        setInvoice(invoices.data.invoices);
        setCReqs(invoices.data.c_reqs);
        setCpReqs(invoices.data.cp_reqs);
      }

      calculateTotalAmount([]); // Initial call with an empty selection
    };

    getData();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelectedCourses([]);
    setTotal(0)
  };

  const calculateTotalAmount = (selectedCourses) => {
    let total = 0;
    const numberOfCertificates = selectedCourses.length;

    if (numberOfCertificates === 1) {
      total = 1000;
    } else if (numberOfCertificates === 2) {
      total = 1600;
    } else if (numberOfCertificates === 3) {
      total = 2000;
    } else if (numberOfCertificates === 4) {
      total = 2500;
    } else if (numberOfCertificates >= 5) {
      total = 3000;
    }
    setTotal(total);
  };

  function handleSubmit(event) {
    event.preventDefault();
    const url = global.config.URL.api.lms + 'request-certificate';
    setSub(true)
    if (selectedCourses.length === 0) {
      setError("Required Courses");
    }
    const formData = new FormData();
    formData.append('img', file);
    formData.append('tr_id', tid);
    formData.append('address', address);
    selectedCourses.forEach((courseId, index) => {
      formData.append(`course_ids[${index}]`, courseId);
    });
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    axios.post(url, formData, config).then((response) => {
      setTid(null)
      setAddress('')
      setFile(null)
      setSelectedCourses([])
      if (response.data.success && response.data.Click2Pay) {
        setError("Please wait while we redirect you to the payment method.");
        window.location.href = response.data.Click2Pay;
      } else if (response.data.success === false) {
        setError(response.data.message);
        setSub(false);
      } else {
        setError(response.data.message || response.data.error || 'Unable to start payment.');
        setSub(false);
      }
    }).catch((err) => {
      setError(err.response?.data?.message || err.response?.data?.error || 'Payment request failed.');
      setSub(false);
    });
  }

  const handleChangeCourse = (event) => {
    const { value } = event.target;
    setSelectedCourses(value);
    calculateTotalAmount(value); // Update total whenever selected courses change
  };
  const payNow = async () => {
    setSub(true);
    setError(null);
    axios.defaults.headers.common["Authorization"] = `Bearer ${global.config.Token}`;

    const url = global.config.URL.api.lms + 'pay-certificate-fee';

    try {
      const response = await axios.get(url);
      const paymentUrl = response.data?.Click2Pay;

      if (response.data?.success && paymentUrl) {
        window.location.href = paymentUrl;
        return;
      }

      const message = response.data?.message || response.data?.error || 'Unable to start payment. Please try again.';
      setError(message);
      Swal.fire({ icon: 'error', title: 'Payment Error', text: message });
    } catch (err) {
      const message = err.response?.data?.message || err.response?.data?.error || 'Payment request failed. Please try again.';
      setError(message);
      Swal.fire({ icon: 'error', title: 'Payment Error', text: message });
    } finally {
      setSub(false);
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumbs title="Certificate" breadcrumbItem="Select Course To Get Certificate" />

        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              {invoices ? invoices.map((batch, i) => (
                <Tab label={"Batch " + batch.batch.number} {...a11yProps(i)} key={i} />
              )) : ""}
            </Tabs>
          </Box>

          {invoices ? invoices.length > 0 ? invoices.map((batch1, i) => (
            <TabPanel value={value} index={i} key={i}>
              <Row>
                {batch1.courses.map((course, j) => (
                  <Col md={4} sm={6} className="mt-3" key={j}>
                    <Card sx={{ maxWidth: 345 }}>
                      <CardActionArea>
                        <CardMedia
                          component="img"
                          height="140"
                          image={global.config.URL.img.public + course.course.course_detail.img}
                          alt="course image"
                        />
                        <CardContent>
                          <Typography gutterBottom variant="h6" className='heading' component="div">
                            {course.course.name}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                      <CardActions>
                        {!course.fail ? <Button size="small" onClick={() => navigateToModule(course.id)} className='btnn'>
                          <i className='fa fa-arrow-down'></i> &nbsp; Download Certificate
                        </Button> :
                          <>

                            <small style={{ color: 'red' }}>Your Course Score less than 30%</small>
                          </>
                        }

                      </CardActions>
                    </Card>
                  </Col>
                ))}


                <Col md={12} className="mt-3">
                  <Card>
                    <Row>
                      {!cReqs ?

                        <>
                          <Col md={6} sm={6} className="mt-3 p-5">
                            <h4 className="card-title">Dear PFTPian</h4>
                            <p>If you require a hard copy, complete the form below with your TCS address and pay for delivery charges.</p>

                          </Col>
                          <Col md={6} sm={6} className="mt-3">
                            <Box className="p-3">
                              <form onSubmit={handleSubmit} className="m-3">
                                <FormControl fullWidth className="mt-3">
                                  <InputLabel>Select Course</InputLabel>
                                  <Select
                                    multiple
                                    value={selectedCourses}
                                    onChange={handleChangeCourse}
                                    label="Select Courses"
                                  >
                                    {batch1.courses.map((course) => (
                                      !course.fail ?
                                        <MenuItem key={course.id} value={course.id}>{course.course.name}</MenuItem>
                                        : ""
                                    ))}
                                  </Select>
                                </FormControl>
                                <FormControl fullWidth className="mt-3">
                                  <label>Postal Address:</label>
                                  <textarea className='form-control' placeholder="Enter your postal address" onChange={(e) => setAddress(e.target.value)}>{address}</textarea>
                                </FormControl>
                                {error && <p className='text-danger mt-2'>{error}</p>}
                                {submitting ?

                                  <Button type='button' disabled className="btn mt-3 btn-success" style={{ color: "#fff" }}>Please Wait...</Button>
                                  :
                                  <Button type='submit' className="btn mt-3" style={{ backgroundColor: "#b4edb4", color: "#fff" }}>Pay Now ({total}rs)</Button>

                                }
                              </form>
                            </Box>
                          </Col>


                        </>
                        : ""}

                      <Col md={12} sm={6} className="mt-3">
                        <h3 className='p-3'>Certificate Requests</h3>
                        {error && cReqs && <p className='text-danger px-3'>{error}</p>}
                        <Table responsive={true}>
                          <thead>
                            <tr className="table-dark">
                              <th>
                                ID
                              </th>
                              <th>
                                Date
                              </th>
                              <th>
                                Status
                              </th>
                              <th>
                                Amount
                              </th>
                              <th>
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              cReqs ?
                                <tr className="table-danger">
                                  <td>
                                    {cReqs.tr_id}
                                  </td>
                                  <td>
                                    {cReqs.due_date}
                                  </td>
                                  <td>
                                    <span className='badge bg-danger'>Unpaid</span>
                                  </td>
                                  <td>
                                    {cReqs.amount}
                                  </td>
                                  <td>
                                    {
                                      submitting ?
                                        <Button type='button' className="btn" style={{ backgroundColor: "#b4edb4", color: "#fff" }}>Please Wait Redirecting... </Button>
                                        :
                                        <Button type='button' onClick={() => payNow()} className="btn" style={{ backgroundColor: "#b4edb4", color: "#fff" }}>Pay Now </Button>
                                    }
                                  </td>
                                </tr>
                                : ""}
                            {
                              cpReqs.length > 0 ?
                                cpReqs.map((cp) => {
                                  return (
                                    <tr className="table-success">
                                      <td>
                                        {cp.tr_id}
                                      </td>
                                      <td>
                                        {cp.paid_at}
                                      </td>
                                      <td>
                                        <span className='badge bg-success'>Paid</span>
                                      </td>
                                      <td>
                                        {cp.amount}
                                      </td>
                                      <td>

                                      </td>
                                    </tr>
                                  )
                                })
                                : ""
                            }



                          </tbody>
                        </Table>
                      </Col>

                    </Row>
                  </Card>
                </Col>



              </Row>
            </TabPanel>
          )) : <Col md={12}><Card body className='p-3'><CardText><h2>Dear PFTPians,</h2> You will be able to access your certificate after the GAT examination.</CardText></Card></Col> :
            <SkeletonAnimation />
          }
        </Box>
      </div>
    </React.Fragment>
  );
}

function SkeletonAnimation() {
  return (
    <Row>
      {[...Array(3)].map((_, i) => (
        <Col md={4} sm={6} className="mt-3" key={i}>
          <Stack spacing={1}>
            <Skeleton animation="wave" variant="rectangular" width={'100%'} height={140} />
            <Skeleton width="60%" />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" height={20} sx={{ fontSize: '1rem' }} />
          </Stack>
        </Col>
      ))}
    </Row>
  );
}
